import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b29d0af8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "batch-search" }
const _hoisted_2 = { class: "batch-search-content" }
const _hoisted_3 = { class: "batch-search-title" }
const _hoisted_4 = { class: "batch-search-input" }
const _hoisted_5 = { class: "text-rt mt_30 commit" }

import { ref, nextTick } from 'vue'
import { t } from '@/plugins/i18n'
import bus from '@/util/useBus'

export default /*#__PURE__*/_defineComponent({
  props: {
  title: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props

let key = ''
const visible = ref(false)
const formData = ref('')
const textareaRef = ref()
const closeModal = () => {
  bus.emit('close')
}
bus.on('close', (k: string) => {
  visible.value = false
})
const search = () => {
  closeModal()
  const params: any = {}
  params[key] = formData.value.split(/\n/).filter((v:any) => !!v || (v === 0))
  console.log(params)
  bus.emit('batchSearch' + props.title, params)
}
// 双击搜索展示弹窗
bus.on('dblclickSearch', (k: string) => {
  formData.value = ''
  key = k
  visible.value = true
  nextTick(() => {
    textareaRef.value && textareaRef.value.focus()
  })
})
const changeInput = () => {
  formData.value = formData.value
    .split(/\n/)
    .splice(0, 500)
    .join('\n')
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      "model-value": visible.value,
      "show-close": false,
      width: "500px",
      top: "20vh",
      "destroy-on-close": "",
      onClosed: closeModal
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('批量搜索')), 1),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_input, {
              type: "textarea",
              modelValue: formData.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event)),
              placeholder: _unref(t)('每行一个（支持excel复制黏贴）'),
              class: "input",
              onInput: changeInput,
              ref: (_value, _refs) => {
                _refs['textareaRef'] = _value
                textareaRef.value = _value
              }
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              type: "default",
              onClick: closeModal,
              class: "btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: search,
              class: "btn",
              disabled: !formData.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model-value"])
  ]))
}
}

})